import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha';
import { TooltipModule } from '@amin-karimi/ng2-tooltip-directive';
import { SharingModalComponent } from './pages/private/resources/sharing-modal/sharing-modal.component';
import { ComponentModule } from 'src/app/components/component.module';
import { PipesModule } from './pipes/pipes.module';
import {TranslationService} from "./services/translation.service";
import { Events } from './services/events.service';
import { PtyWsService } from "./services/pty-ws.service";
import { PtyLdService } from "./services/pty-ld.service";
import { DeepLinkService } from "./services/deep-link.service";
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeAr from '@angular/common/locales/ar';
import localeZh from '@angular/common/locales/zh';
import localeFr from '@angular/common/locales/fr';
import localeHi from '@angular/common/locales/hi';
import localeId from '@angular/common/locales/id';
import localePt from '@angular/common/locales/pt';
import localeRu from '@angular/common/locales/ru';
import { AppInitService } from './app-init.service';
import {BadgeService} from "./services/badge.service";
registerLocaleData(localeEs);
registerLocaleData(localeAr);
registerLocaleData(localeZh);
registerLocaleData(localeFr);
registerLocaleData(localeHi);
registerLocaleData(localeId);
registerLocaleData(localePt);
registerLocaleData(localeRu);

export function initializeApp1(appInitService: AppInitService) {
  return (): Promise<any> => {
    return appInitService.Init();
  }
}

@NgModule({
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [AppComponent, SharingModalComponent],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        IonicModule.forRoot(),
        IonicStorageModule.forRoot({
            name: '__ptypath', driverOrder: ['indexeddb', 'sqlite', 'websql']
        }),
        HttpClientModule,
        SocketIoModule,
        RecaptchaModule,
        FormsModule,
        ReactiveFormsModule,
        // CommonModule,
        TooltipModule,
        ComponentModule,
        PipesModule
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        PtyWsService,
        PtyLdService,
        TranslationService,
        BadgeService,
        Events,
        DeepLinkService,
        AppInitService,
        //{ provide: APP_INITIALIZER,useFactory: initializeApp1, deps: [AppInitService], multi: true}
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
